import * as actionTypes from "../actions/actionTypes.js";

const initialState =[]

export default function languageListReducer(state = initialState, action) {
  //console.log(state);

  if (action === undefined) {
    return state;
  }
  switch (action.type) { 
    case actionTypes.GET_LANGUAGE_LIST_SUCCESS:
      return action.payload;
      //return Object.assign({}, state, {languageList: action.payload});
    default:
      return state;
  }
}
